import { __awaiter } from "tslib";
import { assertEx } from '@xyo-network/sdk-xyo-js';
import { createPaymentToken } from '../../rebilly';
import { createTransaction } from '../../xy';
import createPaymentTokenParams from './createPaymentTokenParams';
const cleanCartItems = (items) => {
    const cleanItems = [];
    for (const item of items !== null && items !== void 0 ? items : []) {
        items.push({
            planId: item.planId,
            quantity: item.quantity,
        });
    }
    return cleanItems;
};
const buildPayload = (params, coupons, items, paymentToken) => {
    var _a, _b;
    return {
        billing: params.billing,
        coupons,
        customFields: (_a = params.customFields) !== null && _a !== void 0 ? _a : {},
        customer: (_b = params.customer) !== null && _b !== void 0 ? _b : {},
        items: items !== null && items !== void 0 ? items : {},
        paymentToken,
        sandbox: params.sandbox,
        shipping: params.shipping,
    };
};
const processPayment = (params) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    let result = {};
    const { log } = params;
    assertEx(((_b = (_a = params.cartInfo.items) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0, 'Missing Items');
    try {
        const paymentToken = (_c = params.paymentToken) !== null && _c !== void 0 ? _c : (yield createPaymentToken(createPaymentTokenParams(params)));
        const coupons = [];
        const discountCode = (_d = params.cartInfo.discountCode) === null || _d === void 0 ? void 0 : _d.code;
        if (discountCode) {
            coupons.push({ couponId: discountCode });
        }
        const items = cleanCartItems((_e = params.cartInfo.items) !== null && _e !== void 0 ? _e : []);
        if (paymentToken) {
            const payload = buildPayload(params, coupons, items, paymentToken);
            result = yield createTransaction(payload);
            if (result.errors) {
                for (const error of result.errors) {
                    log === null || log === void 0 ? void 0 : log.warn('createTransaction', error);
                }
                log === null || log === void 0 ? void 0 : log.warn('processPayment Failed');
            }
        }
        else {
            throw new Error('Failed to create Payment Token');
        }
    }
    catch (ex) {
        log === null || log === void 0 ? void 0 : log.error('processPayment', ex);
        result = { errors: [ex] };
        throw ex;
    }
    return result;
});
export default processPayment;
//# sourceMappingURL=processPayment.js.map